<template>
        <div class="photogrid">
            <div class="photo-card" v-for="photo in photos"  :key="photo.id">
                <!-- there must be a better way to pass the needed data to the other view -->
                <router-link :to="{name: 'photo-view', params: {id: photo.url, photo: photo}}">
                    <img id="image" v-lazy="getImgUrl(photo)"/>
                </router-link>
            </div>  
        </div>
</template>

<script>
export default {
    name: 'photo-grid',
    props: ['photos'],
    methods: {
        getImgUrl(photo) {
            return photo.thumbnailUrl
        },
    },

}

</script>

<style>
div {
    display: flex;
    flex-wrap: wrap;
}
.photocard {
    max-width: 150px;
    opacity: 1;
    transition: 0.3s ease;
}
.image {
    opacity: 1;
    transition: 0.3s ease;
}
/* this hover effect doesn't work, why?*/
.photocard:hover{
    opacity: 0.5;
}

</style>